import { render, staticRenderFns } from "./loadShipmentModal.vue?vue&type=template&id=3db4d6e7&scoped=true&"
import script from "./loadShipmentModal.vue?vue&type=script&lang=js&"
export * from "./loadShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./loadShipmentModal.vue?vue&type=style&index=0&id=3db4d6e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4d6e7",
  null
  
)

export default component.exports